import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';

export interface MerchantState {
  merchant: MerchantDetailsModel | null;
  infoPopupOpen: boolean;
}

const state: MerchantState = {
  merchant: null,
  infoPopupOpen: false,
};

export default state;
